import React from 'react';
import { DefaultDivider } from '../Common/DefaultDivider';

export const LinksDivider = () => <DefaultDivider name="Links" icon="linkify" />;
